import React from 'react';
import { CtaLink, Heading, Kicker, Lead } from './ui';
import { whatsappUrl } from '../../data/links';
import { IMAGES } from '../../data/vcars';
export function SolutionSection() {
  return <section className="bg-[#0c0e12]" data-id="element-90" data-mp="21z72u9lvedz9">
      <div className="mx-auto grid w-full max-w-6xl items-center gap-10 px-5 py-14 sm:px-8 sm:py-20 lg:grid-cols-2 lg:gap-16 lg:px-12 lg:py-28" data-id="element-91" data-mp="21y5qm1t4blfy">
        <div data-id="element-92" data-mp="199qd5jpmxb6q">
          <Kicker data-id="element-93" data-mp="199gmdtwrmzzz">La solución</Kicker>
          <Heading className="mt-4 text-white" data-id="element-94" data-mp="19ai7ysber4vy">
            VCARS te ayuda a encontrar el auto ideal para vos
          </Heading>
          <Lead className="mt-4 text-white/60" data-id="element-95" data-mp="15arcibaxs0l3">
            Nos contás qué buscás y te orientamos con opciones reales según tu
            presupuesto, necesidad y forma de pago.
          </Lead>
          <p className="mt-4 text-base leading-relaxed text-white/55" data-id="element-96" data-mp="1ebfqx748s2yi">
            Ya sea que estés buscando tu primer auto, quieras cambiar por un
            modelo más nuevo, necesites un vehículo familiar o busques una
            unidad para trabajar, podemos ayudarte a encontrar alternativas
            disponibles y convenientes.
          </p>
          <CtaLink href={whatsappUrl('Hola VCARS, quiero empezar mi búsqueda. Les cuento qué auto necesito.')} label="Empezar mi búsqueda" className="mt-8" data-id="element-97" data-mp="1ijhk9je8kgii" />
        </div>

        <img src={IMAGES.keys} alt="Cliente recibiendo las llaves de su vehículo" className="h-64 w-full rounded-2xl object-cover sm:h-80 lg:h-[26rem]" data-id="element-98" data-mp="1sgce3ozkdsqg" />
      </div>
    </section>;
}